module.exports = __webpack_public_path__ + "static/hunter-douglas-design-0f7eb2502424b14b1bc75e93e55948b7.png";